import { render } from "./OfferForm.vue?vue&type=template&id=40d29b1c"
import script from "./OfferForm.vue?vue&type=script&lang=js"
export * from "./OfferForm.vue?vue&type=script&lang=js"
script.render = render

export default script